<template>
  <div>
    <ThirdPartiesVueContainer />
  </div>
</template>

<script>
import ThirdPartiesVueContainer from "../../containers/ThirdPartiesVueContainer.vue";
export default {
  name: "ClientProfileThirdParties",
  components: {
    ThirdPartiesVueContainer
  },
  data() {
    return {};
  },

  computed: {},
  methods: {}
};
</script>

<style scoped>
</style>
